import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import SORT_ORDER from '@tekion/tekion-base/constants/sortOrder';
import Icon, { SIZES } from '../../../../atoms/FontIcon';
import style from './headerWithSortIndicator.module.scss';
var SortOrderIndicator = function SortOrderIndicator(props) {
  var sortType = props.sortType;
  return /*#__PURE__*/React.createElement(Icon, {
    size: SIZES.S,
    className: cx(style.accordian, _defineProperty({
      'icon-arrow-down': sortType === SORT_ORDER.DESC,
      'icon-arrow-up': sortType === SORT_ORDER.ASC
    }, "".concat(style.sortIndicator, " icon-sort-by"), !sortType))
  });
};
SortOrderIndicator.propTypes = {
  sortType: PropTypes.oneOf([SORT_ORDER.ASC, SORT_ORDER.DESC])
};
SortOrderIndicator.defaultProps = {
  sortType: EMPTY_STRING
};
export default /*#__PURE__*/memo(SortOrderIndicator);